module.exports = __webpack_public_path__ + "img/Banner4中文.3a9b7e3d.png";